import React from 'react'
import PropTypes from 'prop-types'
import { StyledModal } from './component.styles'
import AddProgramStartDate from './AddProgramStartDate'
import ModalHeader from 'components/ModalHeader'
import ModalFooter from 'components/ModalFooter'

const ProgramStartDateModal = ({
  currentStep,
  errors,
  goBack,
  flowLabel,
  handleChange,
  handleClose,
  handleNextButtonClick,
  hasApiError,
  isValid,
  isSubmitting,
  modals,
  touched,
  values,
}) => {
  const currentModal = modals?.[currentStep] || {}
  const { cancelLabel, helpCopy, nextLabel } = currentModal

  return (
    !!modals && (
      <StyledModal
        dataTestId="step-modal-modal"
        isModalOpen={true}
        modalClose={() => handleClose}
      >
        <ModalHeader
          flowLabel={flowLabel}
          handleClose={handleClose}
          handleGoBack={goBack}
          showBackButton={false}
        />
        <AddProgramStartDate
          errors={errors}
          handleChange={handleChange}
          modalData={modals[0]}
          touched={touched}
          values={values}
        />
        <ModalFooter
          cancelButtonText={cancelLabel}
          handleNextButtonClick={() => handleNextButtonClick(true)}
          hasApiError={hasApiError}
          helpCopy={helpCopy}
          isSubmitting={isSubmitting}
          isValid={true}
          modalName="program-start-date"
          nextButtonText={nextLabel}
          showCancelButton={false}
        />
      </StyledModal>
    )
  )
}

ProgramStartDateModal.propTypes = {
  currentStep: PropTypes.number,
  errors: PropTypes.object,
  flowLabel: PropTypes.string,
  goBack: PropTypes.func,
  handleCancelButtonClick: PropTypes.func,
  handleChange: PropTypes.func,
  handleClose: PropTypes.func,
  handleNextButtonClick: PropTypes.func,
  hasApiError: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  isValid: PropTypes.bool,
  modals: PropTypes.array,
  touched: PropTypes.object,
  values: PropTypes.object,
}

export default ProgramStartDateModal
